import { isFutureDate } from '@/lib/helpers/date.helpers'
import type { CampaignFormType } from '@/lib/types/campaign.types'
import type { TrafficSourceCostsType } from '@/lib/types/traffic-source-costs.types'

type DefaultTrafficSourceGroup = {
  sourceIndexes: number[]
} & Partial<TrafficSourceCostsType>

export function getDefaultTrafficSourceGroup(currency: string) {
  return {
    cpc: { amount: 0, currency },
    cpa: 0,
    sourceIndexes: [],
    rateCpa: 0,
    invoiceRateCpc: 0,
    invoiceRateCpa: 0,
  } satisfies DefaultTrafficSourceGroup
}

export const defineCampaignEndReason = (campaign: CampaignFormType) => {
  if (campaign.validUntil && !isFutureDate(campaign.validUntil)) {
    return 'The campaign ended because it passed its end date. Set a new end date to resume.'
  } else if (
    !campaign.perUserLimit &&
    campaign.currentClicks &&
    campaign.maxClicks &&
    campaign.currentClicks >= campaign.maxClicks
  ) {
    return 'The campaign ended because the set click limit was reached. Increase the limit to resume.'
  } else if (
    campaign.currentBudgetSpent &&
    campaign.budgetLimit &&
    campaign.currentBudgetSpent >= campaign.budgetLimit
  ) {
    return 'The campaign ended because the set budget was reached. Increase the budget to resume.'
  } else {
    return ''
  }
}
